module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "full-w flex-column start"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(this.appointment ? _vm.$t('static.appointments.edit.title') : _vm.$t('static.appointments.create.title')))]), _vm._v(" "), (_vm.appointment) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1rem"
    },
    on: {
      "click": _vm.goToOverviewPage
    }
  }, [_vm._v(_vm._s(_vm.$t('static.appointments.edit.editButton')))]) : _vm._e()]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.form,
      "hasLabel": true,
      "translation": "form.orders"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-w flex space-between wrap"
  }, [_c('div', {
    staticClass: "flex wrap margin-b-10"
  }, [_c('el-button', {
    staticClass: "dark margin-b-10",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: " margin-b-10",
    on: {
      "click": _vm.createAppointment
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [(_vm.destroy && _vm.appointment) ? _c('el-button', {
    staticClass: "danger margin-b-10",
    on: {
      "click": function($event) {
        return _vm.destroyAppointment(_vm.appointment.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.delete')) + "\n      ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-760007ea","hasScoped":false}!./src/app/components/addAppointment/addAppointment.html
// module id = 3067
// module chunks = 1